export const FETCH_REVENUE_BY_REQUEST = 'FETCH_REVENUE_BY_REQUEST';
export const FETCH_REVENUE_BY_SUCCESS = 'FETCH_REVENUE_BY_SUCCESS';
export const FETCH_REVENUE_BY_FAILURE = 'FETCH_REVENUE_BY_FAILURE';
